<template>
  <header
    class="header absolute top-0 flex items-center justify-between w-full bg-white shadow-lg"
  >
    <a
      v-if="!isIframe"
      :href="utmHref('https://www.liverpool.ac.uk/', 'logo-click')"
      aria-label="University of Liverpool"
      target="_blank"
      class="block h-8 md:h-10 focus-a"
    >
      <img
        src="@/assets/logo-full.svg"
        alt="University logo"
        class="h-full w-auto"
      />
    </a>
    <div v-if="!isIframe" class="flex-a">
      <ul v-if="!mobile" class="flex">
        <li
          v-for="(item, i) in options.calls_to_action"
          :key="`${item.href}-${i}`"
        >
          <Button
            type="external"
            :text="item.call_to_action"
            :path="item.href"
            :utm="`tier-1-cta`"
            class="btn-sm btn-primary mr-2"
          />
        </li>
      </ul>
      <Navigation v-if="!isIframe" class="ml-2" />
    </div>
  </header>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Navigation from '@/components/Navigation.vue'
import Button from '@/components/buttons/Button.vue'

export default {
  name: 'Header',

  components: {
    Button,
    Navigation
  },

  computed: {
    ...mapState(['touch', 'mobile', 'isIframe']),
    ...mapGetters(['options'])
  }
}
</script>
